// starting off with nm2020 theme colors and we will replace as we go
export const DEFAULT_COLORS = {
  // swatches
  neutral: {
    white: '#fff',
    grayLight30: '#f8fafc',
    grayLight20: '#edf0f3',
    grayLight10: '#d5d5d5',
    grayLight05: '#bebebe',
    gray: '#8a8a8a',
    grayDark10: '#696969',
    grayDark20: '#4a4a4a',
    grayDark30: '#2c2c2c',
    black: '#000',
  },
  sky: {
    sky: '#a9c8ff',
    sky80: '#bad3ff',
    sky60: '#cbdeff',
    sky40: '#dde9ff',
    sky20: '#eef4ff',
  },
  navy: {
    navy: '#001739',
    navy80: '#334561',
    navy60: '#667488',
    navy40: '#99a2b0',
    navy20: '#d6dadf',
  },
  yellow: {
    yellow: '#ffd268',
    yellow80: '#ffdb86',
    yellow60: '#ffe4a4',
    yellow40: '#ffedc3',
    yellow20: '#fff6e1',
  },
  maroon: {
    maroon: '#88103b',
    maroon80: '#a04062',
    maroon60: '#b87089',
    maroon40: '#cf9fb1',
    maroon20: '#e7cfd8',
  },
  green: {
    green: '#00504b',
    green80: '#33736f',
    green60: '#669693',
    green40: '#99b9b7',
    green20: '#ccdcdb',
  },
  violet: {
    violet: '#2c258b',
    violet80: '#5651a2',
    violet60: '#807cb9',
    violet40: '#aba8d1',
    violet20: '#d5d3e8',
  },
  offWhite: {
    offWhite: '#f4f2dc',
    offWhite80: '#f6f5e3',
    offWhite60: '#f8f7ea',
    offWhite40: '#fbfaf1',
    offWhite20: '#fdfcf8',
  },
  cta: {
    lightTheme: '#356ed4',
    lightThemeHover: '#2356af',
    lightThemeActive: '#001739',
    lightThemeDisabled: '#696969',
    darkTheme: '#ffd268', // yellow.yellow
    darkThemeHover: '#f3b525',
    darkThemeActive: '#eaa400',
    darkThemeDisabled: '#b5b5b5',
  },
  link: { lightTheme: '#2356af' },
};

export default DEFAULT_COLORS;

